module.exports = __webpack_public_path__ + "media/customizations/hylandtrail/back-2271b978e8b90c314c08c6501b9e0c59.jpg";